import { render, staticRenderFns } from "./ui-badge-ordination.vue?vue&type=template&id=06eb46ce&scoped=true"
import script from "./ui-badge-ordination.vue?vue&type=script&lang=js"
export * from "./ui-badge-ordination.vue?vue&type=script&lang=js"
import style0 from "./ui-badge-ordination.vue?vue&type=style&index=0&id=06eb46ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eb46ce",
  null
  
)

export default component.exports